import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import DatePicker from 'react-datepicker';
import Toggle from 'react-toggle';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import StaffFlightEditModal from './Elements/StaffFlightEditModal';
import getLocale from '../../i18n/getLocale';

class StaffFlightsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      modal_props: false,
      aircraft_models_list: [],
      flight_hours: [],
      flight_hours_totals: [],
      total_str: '',
      ifr_str: '',
      noturno_str: '',
      h_nav_str: '',
      date: '',
      app: '',
      daytime: '',
      nighttime: '',
      freight_ex: 0,
      observations: '',
      fb_list: [
        {value: "DC", label: "DC"},
        {value: "IN", label: "IN"},
        {value: "2P", label: "2P"},
        {value: "1P", label: "1P"},
        {value: "CM", label: "CM"},
        {value: "PS", label: "PS"},
      ],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.delete = this.delete.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }   
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'open'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/horas/voos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/contratos');
        if (responseJson.status === 'success') {
          self.setState({flight_hours: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/horas/voos/totais/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_hours_totals: responseJson.data});
        }
      }).then(() => {
        self.modalPropsOff();
        self.handleAlert(event.message, event.status, 'open');
     }); /* Horas totais */ }); /* Overlay */ 
    });
  }


  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/horas/voos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/contratos');
        if (responseJson.status === 'success') {
          self.setState({flight_hours: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/horas/voos/totais/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_hours_totals: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista/modelos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
     }); /* Lista de frotas */ }); /* Horas totais */ }); /* Overlay */ 
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      aircraft_model_id: this.state.aircraft_model_id,
      staff_id: this.props.match.params.id,
      fb: this.state.fb,
      total_str: this.state.total_str,
      ifr_str: this.state.ifr_str,
      noturno_str: this.state.noturno_str,
      h_nav_str: this.state.h_nav_str,
      date: this.state.date,
      app: this.state.app,
      daytime: this.state.daytime,
      nighttime: this.state.nighttime,
      company: this.state.company,
      freight_ex: this.state.freight_ex,
      observations: this.state.observations,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/horas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'closed'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  modalPropsOff () {
    this.setState({overlay: {message: '', type: '', status: 'closed'}, modal_props: false});
  }
  
  loadDataEditModal(value, event) {
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var id = (value);
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/hora/voo/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_staff_flight_edit:responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.showModal();
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {
    
    var botao = (
      <div className="btn-group">
        <button onClick={this.loadDataEditModal.bind(this, cell)} className='btn btn-sm btn-primary' alt={this.locale.general.editar} title={this.locale.general.editar}><i className="fa fa-fw fa-pencil"></i></button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var staff_flight_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.AdicionarHorasDoTripulante.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/hora/' + staff_flight_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Tripulantes.AdicionarHorasDoTripulante.titulo}</h3>
      <Link to={"/funcionario/editar/" + this.props.match.params.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Aeronave}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.placeholder.SelecionarAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.FB}:</label>
              <Select
                className="form-field-name"
                name="fb"
                value={this.state.fb}
                searchable={true}
                placeholder={this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'fb')}
                options={this.state.fb_list}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Total}:</label>
              <input value={this.state.total_str} name="total_str" className="form-control" onChange={this.handleChange.bind(this, 'total_str')} placeholder="00000:00" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.IFR}:</label>
              <input value={this.state.ifr_str} name="ifr_str" className="form-control" onChange={this.handleChange.bind(this, 'ifr_str')} placeholder="00000:00" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Noturno}:</label>
              <input value={this.state.noturno_str} name="noturno_str" className="form-control" onChange={this.handleChange.bind(this, 'noturno_str')} placeholder="00000:00" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.HNav}:</label>
              <input value={this.state.h_nav_str} name="h_nav_str" className="form-control" onChange={this.handleChange.bind(this, 'h_nav_str')} placeholder="00000:00" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Data}:</label>
              <DatePicker value={this.state.date} onChange={this.handleChangeDatePicker.bind(this, 'date')} className="form-control" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.APP}:</label>
              <input value={this.state.app} name="app" mask="9999999999" className="form-control" onChange={this.handleChange.bind(this, 'app')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Diurno}:</label>
              <input value={this.state.daytime} name="daytime" mask="9999999999" className="form-control" onChange={this.handleChange.bind(this, 'daytime')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Noturno}:</label>
              <input value={this.state.nighttime} name="nighttime" mask="9999999999" className="form-control" onChange={this.handleChange.bind(this, 'nighttime')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Empresa}:</label>
              <Select
                className="form-field-name"
                name="company"
                value={this.state.company}
                searchable={true}
                placeholder={this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'company')}
                options={[
                  {value: "1", label: this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.opcoesEmpresa.Omni},
                  {value: "2", label: this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.opcoesEmpresa.Outros},
                ]}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.CargaExterna}:</label>
              <br/>
              <Toggle
                defaultChecked={this.state.freight_ex}
                checked={this.state.freight_ex}
                aria-label='No label tag'
                name="freight_ex"
                onChange={this.handleToggleChange.bind(this, 'freight_ex')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.Observacoes}:</label>
              <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
            </div>
          </div>
        </div>
       <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.AdicionarHorasDoTripulante.formulario.botaoAdicionarHoras}</button>
      </form>
      <hr/>
      <h3>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tituloListagemDeHoras}</h3>
      <hr/>
      <BootstrapTable data={this.state.flight_hours} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.semAeronaves}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.Modelo}</TableHeaderColumn>
        <TableHeaderColumn dataField="fb" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.FB}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.Total}</TableHeaderColumn>
        <TableHeaderColumn dataField="ifr_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.IFR}</TableHeaderColumn>
        <TableHeaderColumn dataField="noturno_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.Noturno}</TableHeaderColumn>
        <TableHeaderColumn dataField="app" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.APP}</TableHeaderColumn>
        <TableHeaderColumn dataField="daytime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.Diurno}</TableHeaderColumn>
        <TableHeaderColumn dataField="nighttime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.Noturno}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.Data}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaListagemDeHoras.Acoes}</TableHeaderColumn>

      </BootstrapTable>
      <hr/>
      <h3>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tituloTotaisDeHoras}</h3>
      <hr/>
      <BootstrapTable data={this.state.flight_hours_totals} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.semAeronaves}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.Modelo}</TableHeaderColumn>
        <TableHeaderColumn dataField="fb" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.FB}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.Total}</TableHeaderColumn>
        <TableHeaderColumn dataField="ifr_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.IFR}</TableHeaderColumn>
        <TableHeaderColumn dataField="noturno_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.Noturno}</TableHeaderColumn>
        <TableHeaderColumn dataField="app" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.APP}</TableHeaderColumn>
        <TableHeaderColumn dataField="daytime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.Diurno}</TableHeaderColumn>
        <TableHeaderColumn dataField="nighttime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.AdicionarHorasDoTripulante.tabelaTotaisDeHoras.Noturno}</TableHeaderColumn>
      </BootstrapTable>
      <StaffFlightEditModal handleAlert={this.handleAlert} modal_props={this.state.modal_props} data_staff_flight_edit={this.state.data_staff_flight_edit} aircraft_models_list={this.state.aircraft_models_list} refreshTable={this.refreshTable} modalPropsOff={this.modalPropsOff} />
    </div>
  </div>
</div>
    );
  }
}

export default StaffFlightsAdd;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffFlightsAdd.js